module.exports = __webpack_public_path__ + "static/media/094-printer.8e565db7.svg";